import React from 'react';
import { useSelector } from 'react-redux';

import TabsList from '../../../../../../../components/TabsList';
import Dropzone from '../../../../../../../components/Dropzone';
import Textarea from '../../../../../../../components/Textarea';

const Second = ({ handleChange, handleImageUpload, locales, testObject }) => {
  const onDrop = ([file]) => {
    if (file) {
      handleImageUpload(testObject.id, file);
    }
  };

  const { uploadingImage } = useSelector((state) => state.testing);

  return (
    <div className="second">
      <TabsList>
        <div className="page-top-builder">
          <div className="company-name-wrapper">
            <Textarea
              maxLength={20}
              value={testObject.data.companyName}
              delay={300}
              onChange={handleChange}
              placeholder={
                locales.testing.planHomepage.secondTemplate
                  .companyNamePlaceholder
              }
              className="bmc-form-textarea company-name max-h-10"
              name="companyName"
            />
          </div>
          <div className="bg-color">
            <Dropzone
              onDrop={onDrop}
              locales={locales}
              image={testObject.image}
              uploading={uploadingImage}
            />
          </div>
          <div className="headline-wrapper">
            <Textarea
              value={testObject.data.headline}
              delay={300}
              onChange={handleChange}
              placeholder={
                locales.testing.planHomepage.secondTemplate.headlinePlaceholder
              }
              maxLength={54}
              className="bmc-form-textarea headline max-h-28"
              wrapperClassName="margin-bottom-10"
              name="headline"
            />
          </div>
          <div className="explain-wrapper">
            <Textarea
              maxLength={240}
              onChange={handleChange}
              value={testObject.data.explain}
              delay={300}
              placeholder={locales.testing.planHomepage.explainPlaceholder}
              className="bmc-form-textarea explain-business max-h-28"
              wrapperClassName="margin-bottom-20"
              name="explain"
            />
          </div>
        </div>
      </TabsList>
      <br />
      <TabsList>
        <div className="page-bottom-builder">
          <div className="title">
            {locales.testing.planHomepage.secondTemplate.keyFeatures}
          </div>
          <div className="things-wrapper">
            <div className="thing">
              <div className="icon">
                <span>1</span>
                <div className="border" />
              </div>
              <div className="thing-wrapper">
                <Textarea
                  value={testObject.data.thingOne}
                  delay={300}
                  onChange={handleChange}
                  maxLength={240}
                  placeholder={
                    locales.testing.planHomepage.secondTemplate
                      .threeThingsPlaceholder
                  }
                  className="thing-explanation"
                  name="thingOne"
                />
              </div>
            </div>
            <div className="thing">
              <div className="icon">
                <span>2</span>
                <div className="border" />
              </div>
              <div className="thing-wrapper">
                <Textarea
                  value={testObject.data.thingTwo}
                  delay={300}
                  onChange={handleChange}
                  maxLength={240}
                  placeholder={
                    locales.testing.planHomepage.secondTemplate
                      .threeThingsPlaceholder
                  }
                  className="thing-explanation"
                  name="thingTwo"
                />
              </div>
            </div>
            <div className="thing">
              <div className="icon">
                <span>3</span>
                <div className="border" />
              </div>
              <div className="thing-wrapper">
                <Textarea
                  value={testObject.data.thingThree}
                  delay={300}
                  onChange={handleChange}
                  placeholder={
                    locales.testing.planHomepage.secondTemplate
                      .threeThingsPlaceholder
                  }
                  maxLength={240}
                  className="thing-explanation"
                  name="thingThree"
                />
              </div>
            </div>
          </div>
        </div>
      </TabsList>
      <br />
    </div>
  );
};

export default Second;
